const collator = new Intl.Collator('pt-BR', {
  sensitivity: 'base',
  numeric: true
});

// Normaliza valores por tipo
const normalizeValue = (value, type) => {
  if (value === null || value === undefined) return '';

  switch (type) {
    case 'cpf':
    case 'cnpj':
      return String(value).replace(/\D/g, '');

    case 'int':
    case 'decimal':
      return Number(String(value).replace(',', '.')) || 0;

    case 'date':
      return new Date(value).getTime() || 0;

    case 'text':
    default:
      return String(value).toLowerCase();
  }
};

// Obtém valor da coluna
const getColumnValue = (row, column) => {
  // Campo composto
  if (column.composite && column.composite.length) {
    return column.composite
      .map(field => row[field] || '')
      .join(' ')
      .trim();
  }

  // Valor formatado (ordenar pelo que aparece na tela)
  if (typeof column.formatter === 'function') {
    return column.formatter(row);
  }

  return row[column.field];
};

export const sortData = (data, sort, columns) => {
  if (!sort || !sort.field || !sort.direction) return data;

  const column = columns.find(c => c.field === sort.field);
  if (!column) return data;

  const direction = sort.direction === 'asc' ? 1 : -1;

  return [...data].sort((a, b) => {
    // Sort custom por coluna
    if (typeof column.sortFn === 'function') {
      return column.sortFn(a, b) * direction;
    }

    const rawA = getColumnValue(a, column);
    const rawB = getColumnValue(b, column);

    const valA = normalizeValue(rawA, column.type);
    const valB = normalizeValue(rawB, column.type);

    // Texto com acentuação pt-BR
    if (column.type === 'text') {
      return collator.compare(valA, valB) * direction;
    }

    if (valA > valB) return direction;
    if (valA < valB) return -direction;
    return 0;
  });
};
